import { render } from "./HeaderDamand.vue?vue&type=template&id=4531223e"
import script from "./HeaderDamand.vue?vue&type=script&lang=js"
export * from "./HeaderDamand.vue?vue&type=script&lang=js"

import "./HeaderDamand.vue?vue&type=style&index=0&id=4531223e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__